import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { changeRoomsTotal } from '../../../../../../state/advanced/rooms_total';
import { ERoomsTotal } from '../../../../../../../json_query';
import { RoomsTotalComponents } from './roomsTotal';

export const mapStateToProps = (state: IAppState) => ({
  roomsTotal: (state.filters.jsonQuery.rooms_count && state.filters.jsonQuery.rooms_count.value[0]) || ERoomsTotal.Any,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onRoomsTotalChanged: (value: ERoomsTotal) => {
    dispatch(changeRoomsTotal(value));
  },
});

export const RoomsTotal = connect(mapStateToProps, mapDispatchToProps)(RoomsTotalComponents);
